<template>
	<div>
		<slot name="addressdata" v-bind="this"></slot>
	</div>
</template>

<script>
export default {
	data() {
		return {
			firstName: "",
			lastName: "",
			company: "",
			address1: "",
			address2: "",
			city: "",
			country: "",
			zip: "",
			phone: "",
            showForm: false,
			addressText:/^[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ0-9\u00f1\u00d1])*[a-zA-ZÀ-ÿ0-9\u00f1\u00d1]+([a-zA-Z0-9\sÁÉÍÓÚáéíóúÑñ]+)$/,
			patternText:/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s[a-zA-ZÀ-ÿ\u00f1\u00d1])*[a-zA-ZÀ-ÿ\u00f1\u00d1]+([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/,
			patternPhone: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
			patternEmail: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/,
			patternZip: /^[0-9]{5,5}$/,
		}
	},
	props: {
		formData: {
            first_name: "",
            last_name: "",
            company: "",
            address1: "",
            address2: "",
            city: "",
            country: "",
            zip: "",
            phone: "",
            id: ""
		},
	},
	computed: {
		errorFormatFirstName:function () {
			return this.firstName !== "" && !this.patternText.test(this.firstName);
		},
		errorFormatLastName:function () {
			return this.lastName !== "" && !this.patternText.test(this.lastName);
		},
		errorFormatAddress:function () {
			return this.address1 == "" || !this.addressText.test(this.address1);
		},
		errorFormatCity:function () {
			return this.city == "" || !this.patternText.test(this.city);
		},
		errorFormatCountry:function () {
			return this.country == "";
		},
		errorFormatZip:function () {
			return !this.patternZip.test(this.zip);
		},
		errorFormatTel:function () {
			return this.phone !== "" && !this.patternPhone.test(this.phone);
		}
	},
	methods: {
		testKeyTel(e) {
			if(e.target.value.length < 16 && (e.code.startsWith("Digit") || e.code.startsWith("Backspace") || e.key === "-" || e.key === "+" || e.code.startsWith("Space"))) {
				this.phone = e.target.value;
			} else {
				e.target.value = this.phone;
			}
		},
		blockFlow() {
			return this.errorFormatFirstName || this.errorFormatLastName || this.errorFormatAddress || this.errorFormatCity || this.errorFormatCountry || this.errorFormatZip || this.errorFormatTel;
		},
		preventSubmit(e) {
			if(this.blockFlow()){
				e.preventDefault();
				this.submited = true;
			}
		},
		resetData() {
			if(this.formData) {
				this.firstName = this.formData.first_name ? this.formData.first_name : "";
				this.lastName = this.formData.last_name ? this.formData.last_name : "";
				this.company = this.formData.company ? this.formData.company : "";
				this.address1 = this.formData.address1 ? this.formData.address1 : "";
				this.address2 = this.formData.address2 ? this.formData.address2 : "";
				this.city = this.formData.city ? this.formData.city : "";
				this.country = this.formData.country ? this.formData.country : "";
				this.zip = this.formData.zip ? this.formData.zip : "";
				this.phone = this.formData.phone ? this.formData.phone : "";
				this.id = this.formData.id ? this.formData.id : "";
			}
		}
	},
	mounted() {
		this.resetData();
	}
}
</script>
